import { getFileTypeIconName, Icon } from "assets/Icon";
import { Attachment } from "../addendum.types";

type AddendumAttachmentProps = {
	attachment: Attachment;
	isCommunication: boolean;
};

export const AddendumAttachment = ({
	attachment,
	isCommunication,
}: AddendumAttachmentProps) => {
	const fileIcon = getFileTypeIconName(attachment?.file_type);
	return (
		<a
			href={attachment?.file_path}
			type="button"
			download
			target="_blank"
			rel="noopener noreferrer"
			className={`flex w-fit items-center gap-3 rounded-full px-4 py-2 ${isCommunication ? "border text-black hover:bg-white" : "bg-white text-black hover:bg-blue-200 hover:text-white"} `}
		>
			{/* @ts-ignore icon type is valid but not properly typed */}
			<Icon
				icon={fileIcon}
				style={{ height: 24, width: 24 }}
				iconClassName="bg-white rounded-md"
			/>
			<p className="line-clamp-1 w-full overflow-hidden text-ellipsis text-xs !text-black">
				{attachment?.file_name}
			</p>
		</a>
	);
};
